
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.3 14.1l-4.1-3.6 4.1-3.6c.2-.2.2-.5 0-.7s-.5-.2-.7 0L9.5 9.8 5.3 6.1c-.2-.2-.5-.1-.7.1s-.2.5 0 .7l4.1 3.6-4.1 3.6c-.2.2-.2.5 0 .7.1.1.3.2.4.2.1 0 .2 0 .3-.1l4.2-3.7 4.2 3.7c.1.1.2.1.3.1.1 0 .3-.1.4-.2.2-.2.1-.5-.1-.7z"}}),_c('path',{attrs:{"d":"M9.5 20c-2.5 0-4.9-1-6.7-2.8S0 13 0 10.5s1-4.9 2.8-6.7S7 1 9.5 1s4.9 1 6.7 2.8S19 8 19 10.5s-1 4.9-2.8 6.7S12 20 9.5 20zm0-18C4.8 2 1 5.8 1 10.5S4.8 19 9.5 19s8.5-3.8 8.5-8.5S14.2 2 9.5 2z"}})])
          )
        }
      }
    